<template>
  <BaseInput
    ref="baseInputRef"
    v-model="getValue"
    class="phone"
    type="tel"
    :mask="`${PLACEHOLDER} FP PPP PP PP`"
    :tokens="hexTokens"
    :placeholder="isFocus ? `${PLACEHOLDER} XX XXX XX XX` : $t('forms.placeholder.phone')"
    autocomplete="tel-national"
    autofill="tel-national"
    v-bind="$attrs"
    @focus="isFocus = true"
    @blur="isFocus = false"
  />
</template>

<script>
import BaseInput from '~/components/Base/Input'
import { validationNulls, validationCodeNumber } from './helpers'
import { ignoreCodeUaRegoin } from './codes'

const CODE = '+380'
const PLACEHOLDER = '+380'
const LENGTH_NUMBER = 9

export default {
  name: 'BaseInputPhone',
  components: { BaseInput },
  props: {
    value: { type: Object },
  },
  data() {
    return {
      PLACEHOLDER,
      isFocus: false,
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value.tel
      },
      set(v) {
        this.$emit('input', { tel: v, code: CODE })
      },
    },
    hexTokens() {
      return {
        F: {
          pattern: /[1-9]/,
        },
        P: {
          pattern: /[0-9]/,
        },
      }
    },
  },
  watch: {
    getValue(number) {
      this.validationNumber(number)

      const isFullLength = number.length === LENGTH_NUMBER
      this.$emit('onFullLength', isFullLength)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('onValidate', this.getValue)
      const isFullLength = this.getValue.length === LENGTH_NUMBER
      this.$emit('onFullLength', isFullLength)
    })
  },
  methods: {
    validationNumber(number) {
      const isValidNuuls = validationNulls(number)
      const isIgnoreCodes = !validationCodeNumber(number, ignoreCodeUaRegoin)
      const isValidLength = LENGTH_NUMBER === number.length
      const isValid = isValidNuuls
        && isIgnoreCodes
        && isValidLength

      this.$emit('onValidate', isValid)
    },
  },
}
</script>
